module.exports = __webpack_public_path__ + "static/media/7_3.4fa65fc0.png";